import { useState, useEffect, useCallback } from "react";

/**
 * Hook to check if a timeout has been reached
 * @param {number} timeout - The timeout in milliseconds
 * @returns {{timeoutHit: boolean, resetTimeoutHit: function}} An object containing the timeout status and a reset function.
 */
export const useTimeoutHit = (timeout) => {
  const [timeoutHit, setTimeoutHit] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeoutHit(true);
    }, timeout);
    
    return () => clearTimeout(timer);
  }, [timeout]);

  const resetTimeoutHit = useCallback(() => {
    setTimeoutHit(false);
  }, []);

  return { timeoutHit, resetTimeoutHit };
};